<template>
  <button class="chat-button">
    <slot/>
  </button>
</template>

<script>
export default {
  name: 'ChatButton',
};
</script>

<style scoped lang="scss">
.chat-button {
  padding: 0 12px;
  border: solid 1px #3EB2D9;
  color: #3EB2D9;
  height: 28px;
  cursor: pointer;
  background: transparent;
  outline: none;
  border-radius: 3px;
  transition-duration: .2s;

  &:hover {
    color: #FFF;
    background: #3EB2D9;
  }

  &:active {
    background: #2E88A7;
  }
}
</style>